import { render } from "./Home.vue?vue&type=template&id=320287b2&lang=pug&bindings={}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&lang=postcss"
script.render = render

export default script